import React from "react";
import Login, { Restoring } from "../components/Login";

export default function LoginContainer(props) {
    return (
        <>
            {!props.restoring && <Login />}
            {props.restoring && <Restoring />}
        </>
    );
}
